import {find} from '../helpers';

const fade = find('[data-swipe-fade]');
const multiview = find('[data-swipe-multiview]');
const ticker = find('[data-swipe-ticker]');
const product = find('[data-swipe-product]');
const announcements = find('[data-swipe-announcements]');

if (fade) {
    import('./fade');
}

if (multiview) {
    import('./multiview');
}

if (ticker) {
    import('./ticker');
}

if (product) {
    import('./product-images');
}

if (announcements) {
    import('./announcements');
}
